import { render } from "./LicenseAgreement.vue?vue&type=template&id=781b4513&scoped=true"
import script from "./LicenseAgreement.vue?vue&type=script&lang=js"
export * from "./LicenseAgreement.vue?vue&type=script&lang=js"

import "./LicenseAgreement.vue?vue&type=style&index=0&id=781b4513&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781b4513"]])

export default __exports__